import React from 'react';
import PropTypes from 'prop-types';
import Button, { LinkButton } from '@strava/ui/Button';
import { useActivityPublicContext } from '../../ActivityPublicContext';

const CTA = ({ children, href, onClick, modalVariant, ...props }) => {
  const { openSignUpModal, showSignUpModal } = useActivityPublicContext();

  if (showSignUpModal) {
    return (
      <Button
        variant="primary"
        onClick={() => {
          onClick();
          openSignUpModal(modalVariant);
        }}
        {...props}
      >
        {children}
      </Button>
    );
  }
  return (
    <LinkButton variant="primary" href={href} onClick={onClick} {...props}>
      {children}
    </LinkButton>
  );
};

CTA.propTypes = {
  children: PropTypes.node.isRequired,
  href: PropTypes.string.isRequired, // only used by control & variant-b
  modalVariant: PropTypes.string.isRequired, // TODO ADIEL replace with .oneOf( variant const exported from package )
  onClick: PropTypes.func.isRequired
};

export default CTA;
